




































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import apiService from '@/utils/axios';
import { mapGetters } from 'vuex';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import dayjs from 'dayjs';
import axios from 'axios';
import html2pdf from 'html2pdf.js';
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';
export default Vue.extend({
	name: 'bookings',
	props: {
		mobile: Boolean,
	},
	components: {
		flatPickr,
	},
	data: () => ({
		tabselected: 'one',
		snackbar: false,
		selectedItem: null,
		headers: [
			{ text: 'Booked on', value: 'Booked_on' },
			{ text: 'Edited on', value: 'edited_on' },
			// { text: 'Type', value: 'type' },
			{ text: 'Players', value: 'Players' },
			{ text: 'Email', value: 'Email' },
			{ text: 'Court', value: 'court', name: 'court' },
			{ text: 'Venue', value: 'Venue' },
			{ text: 'Time Period', value: 'Time_Period' },
			{ text: 'Price', value: 'Price' },
			{ text: 'Paid', value: 'Paid' },
			{ text: 'Booker', value: 'Booker' },
			{ text: 'Payment', value: 'Payment' },
			{ text: 'Actions', value: 'Actions' },
		],
		items: [],
		items1: [],
		items2: [],
		items3: [],
		currency: null,
		dialog: false,
		cancelDialog: false,
		tempBookingDetails: '',
		pdf: false,
		editedItem: {},
		totalPrice: '',
		totalRefund: '',
		bookingFilters: {
			country: '',
			cities: [],
			players: '',
			venue: [],
			pitches:[]
		},
		reportFilters: {
			country: '',
			cities: [],
			players: '',
			venue: [],
			date_from: '',
			date_to: '',
			pitches:[]
		},
	}),

	computed: {
		...mapGetters([
			'bookings',
			'countries',
			'CitiesBookingOptions',
			'venue',
			'pitchesReport',
			'CitiesOptionsForReport',
			'venuOptionsForReport',
			'reports',
			'playerBookingCancled',
			'customerBookingCancled',
		]),

		datePickerConfig() {
			return {
				wrap: true, // set wrap to true only when using 'input-group'
				altFormat: 'M j, Y',
				altInput: true,
				dateFormat: 'Y-m-d',
				minuteIncrement: 15,
			};
		},
		// getcities(item: any, i: any) {
		// 	console.log('item', item, i, (this as any).CitiesOptionsForReport);
		// 	// return item;
		// 	let val;
		// 	val = (this as any).CitiesOptionsForReport.filter((c: HasuraCity) => c.city_id === item);
		// 	return val.city_name;
		// },
		countryFilterOptions() {
			const countries = [...(this as any).countries];
			const all = { name: 'All', id: null };
			return [all, ...countries];
		},

		cityFilterOptions() {
			if (this.bookingFilters.country == null) {
				return (this as any).CitiesBookingOptions;
			} else {
				return (this as any).CitiesBookingOptions.filter((c: HasuraCity) => c.country_id === (this as any).bookingFilters.country);
			}
		},
		CitiesFilterReport() {
			if (this.reportFilters.country == null) {
				return (this as any).CitiesOptionsForReport;
			} else {
				return (this as any).CitiesOptionsForReport.filter((c: HasuraCity) => c.country_id === (this as any).reportFilters.country);
			}
		},
// 		pitchFilterReport(){

// },
pitchOptions(){
 return (this as any).pitchesReport
},
		venuFilterReport() {
			return (this as any).venuOptionsForReport;
		},
	
		venueOptions() {
			return (this as any).venue;
		},
		totalIdealPrice() {
			let sum = 0;
			let array = [...this.items1, ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment === 'i-deal' || ele.payment === 'Ideal') {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalIdealPricePWA() {
			let sum = 0;
			let array = [...this.items1, ...this.items2];
			array.forEach((ele: any) => {
				console.log("ele", ele)
				if ((ele.type === 'player_booking'|| ele.type == 'Player_booking_cancled') && (ele.payment === 'i-deal' || ele.payment === 'Ideal')) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalIdealPriceLM() {
			let sum = 0;
			let array = [...this.items1, ...this.items3];
			array.forEach((ele: any) => {
				if ((ele.type == 'customer_booking' || ele.type == 'customer_booking_cancled') && (ele.payment === 'i-deal' || ele.payment === 'Ideal')) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalIdealPriceRefund() {
			let sum = 0;
			let array = [...this.items2, ...this.items3];
			console.log("refund array", array)
			array.forEach((ele: any) => {
				console.log("refund element", ele)
				if (ele.payment === 'i-deal' || ele.payment === 'Ideal') {
					sum = sum + ele.price;
				}
			});
			console.log("summmm", sum)
			return sum;
		},
		totalCreditCardPrice() {
			let sum = 0;
			let array = [...this.items1, ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment == 'Credit Card' || ele.payment == 'Credit card') {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalCreditCardPricePWA() {
			let sum = 0;
			let array = [...this.items1, ...this.items2];
			array.forEach((ele: any) => {
				console.log("ele", ele)
				if ((ele.type === 'player_booking'|| ele.type == 'Player_booking_cancled') && (ele.payment == 'Credit Card' || ele.payment == 'Credit card') ) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalCreditCardPriceLM() {
			let sum = 0;
			let array = [...this.items1, ...this.items3];
			array.forEach((ele: any) => {
				if ((ele.type == 'customer_booking' || ele.type == 'customer_booking_cancled') && (ele.payment == 'Credit Card' || ele.payment == 'Credit card') ) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalCreditCardPriceRefund() {
			let sum = 0;
			let array = [ ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment == 'Credit Card' || ele.payment == 'Credit card') {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalInvoicePrice() {
			let sum = 0;
			let array = [...this.items1, ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment == 'Invoice') {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalInvoicePriceRefund() {
			let sum = 0;
			let array = [...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment == 'Invoice') {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalOnLocationPrice() {
			let sum = 0;
			let array = [...this.items1, ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment == 'On Location') {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalOnLocationPricePWA() {
			let sum = 0;
			let array = [...this.items1, ...this.items2];
			array.forEach((ele: any) => {
				if (ele.payment == 'On Location' && (ele.type === 'player_booking'|| ele.type == 'Player_booking_cancled')) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalOnLocationPriceLM() {
			let sum = 0;
			let array = [...this.items1, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment == 'On Location' &&  (ele.type == 'customer_booking' || ele.type == 'customer_booking_cancled')  ) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalOnLocationPriceRefund() {
			let sum = 0;
			let array = [ ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (ele.payment == 'On Location') {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalOtherPaymentPrice() {
			let sum = 0;
			let array = [...this.items1, ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (
					ele.payment !== 'On Location' &&
					ele.payment !== 'Invoice' &&
					ele.payment !== 'i-deal' &&
					ele.payment !== 'Ideal' &&
					ele.payment !== 'Credit Card' &&
					ele.payment !== 'Credit card' &&
					ele.payment !== null
				) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalOtherPaymentPriceRefund() {
			let sum = 0;
			let array = [ ...this.items2, ...this.items3];
			array.forEach((ele: any) => {
				if (
					ele.payment !== 'On Location' &&
					ele.payment !== 'Invoice' &&
					ele.payment !== 'i-deal' &&
					ele.payment !== 'Ideal' &&
					ele.payment !== 'Credit Card' &&
					ele.payment !== 'Credit card' &&
					ele.payment !== null
				) {
					sum = sum + ele.price;
				}
			});
			return sum;
		},
		totalpriceCalculated() {
			return (this as any).calculatePrice([...this.items1, ...this.items2, ...this.items3]);
		},
		totalpriceCalculatedLM() {
			return (this as any).totalCreditCardPriceLM + (this as any).totalIdealPriceLM + (this as any).totalOtherPaymentPrice + (this as any).totalInvoicePrice + (this as any).totalOnLocationPrice
		},
		totalpriceCalculatedPWA() {
			return (this as any).totalCreditCardPricePWA + (this as any).totalIdealPricePWA
		},
		totalpriceToRefund() {
			return (this as any).calculatePrice([...this.items2, ...this.items3]);
		},
		totalpriceToRefundPWA(){
			return (this as any).calculatePrice(this.items2);
		},
		totalpriceToRefundLM(){
			return (this as any).calculatePrice(this.items3);
},
		totalCalculatedAmountAfterRefund() {
			let finalsum =
				(this as any).calculatePrice([...this.items1, ...this.items2, ...this.items3]) - (this as any).calculatePrice([...this.items2, ...this.items3]);
			return finalsum.toFixed(2);
		},
		totalCalculatedAmountAfterRefundPWA() {
			let finalsum =
				(this as any).totalpriceCalculatedPWA - (this as any).totalpriceToRefundPWA
			return finalsum.toFixed(2);
		},
		totalCalculatedAmountAfterRefundLM() {
			let finalsum =
				(this as any).totalpriceCalculatedLM - (this as any).totalpriceToRefundLM
			return finalsum.toFixed(2);
		},
		totalCalculatedAmountBTW() {
			let finalAmmount =
				(this as any).calculatePrice([...this.items1, ...this.items2, ...this.items3]) - (this as any).calculatePrice([...this.items2, ...this.items3]);
			let amount;
			if (this.reportFilters.country === 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9') {
				amount = finalAmmount - (finalAmmount * 100) / 109;
			} else amount = finalAmmount;
			return amount;
		},
		totalCalculatedAmountBTWPWA() {
			let finalAmmount =
			(this as any).totalCalculatedAmountAfterRefundPWA
			let amount;
			if (this.reportFilters.country === 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9') {
				amount = finalAmmount - (finalAmmount * 100) / 109;
			} else amount = finalAmmount;
			return amount;
		},
		totalCalculatedAmountBTWLM() {
			let finalAmmount =
			(this as any).totalCalculatedAmountAfterRefundLM
			let amount;
			if (this.reportFilters.country === 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9') {
				amount = finalAmmount - (finalAmmount * 100) / 109;
			} else amount = finalAmmount;
			return amount;
		},
		totalCalculatedNetSale() {
			let finalAmmount =
				(this as any).calculatePrice([...this.items1, ...this.items2, ...this.items3]) - (this as any).calculatePrice([...this.items2, ...this.items3]);
			let calBTW;
			if (this.reportFilters.country === 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9') {
				calBTW = (finalAmmount * 100) / 109;
			} else calBTW = finalAmmount;
			return calBTW.toFixed(2);
		},
		totalCalculatedNetSalePWA() {
			let finalAmmount =
			(this as any).totalCalculatedAmountAfterRefundPWA
			let calBTW;
			if (this.reportFilters.country === 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9') {
				calBTW = (finalAmmount * 100) / 109;
			} else calBTW = finalAmmount;
			return Number(calBTW).toFixed(2);
		},
		totalCalculatedNetSaleLM() {
			let finalAmmount =
			(this as any).totalCalculatedAmountAfterRefundLM
			let calBTW;
			if (this.reportFilters.country === 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9') {
				calBTW = (finalAmmount * 100) / 109;
			} else calBTW = finalAmmount;
			return Number(calBTW).toFixed(2);
		},
	},
	watch: {
		bookingFilters: {
			handler: async function(newVal) {
				console.log('newVal', newVal);
				await this.$store.dispatch('getLMBookings', newVal);
			},
			deep: true,
		},
		reportFilters: {
			handler: async function(newVal) {
				console.log('newVal', newVal);
				await this.$store.dispatch('getLMReports', newVal);
				await this.$store.dispatch('getPlayerBookingCancled', newVal);
				await this.$store.dispatch('getCustomerBookingCancled', newVal);
			},
			deep: true,
		},
		bookings: {
			handler: async function(newVal) {
				this.items = newVal;
				console.log(this.items, "itemsssm")
			},
			deep: true,
		},
		reports: {
			handler: async function(newVal) {
				this.items1 = newVal;
				this.items1.forEach((obj: any) => {
					this.currency = obj.currency;
				});
			},
			deep: true,
		},
		playerBookingCancled: {
			handler: async function(newVal) {
				this.items2 = newVal;
			},
			deep: true,
		},
		customerBookingCancled: {
			handler: async function(newVal) {
				this.items3 = newVal;
			},
			deep: true,
		},
	},
	async mounted() {
		this.$store.commit('setBreadcrumb', { root: 'Bookings', path: 'View All' });
		await (this as any).loadItems();
		this.$store.commit('setLoadingState', false);
		console.log('mobile', this.mobile);
	},
	methods: {
		async onRowClick(item: any) {
      // This method will be called when a row is clicked
	  if(item.type == 'player_booking' || item.type == 'customer_booking'){
		console.log('Row Clicked. Row Data:', item);
		await this.$store.commit('setSelectedBookingEditedDate', item)
		this.$router.push({ name: 'venue', params: { id: item.location_id } });
	  }
      // You can use the row data (item) as needed
    },
		replaceAndInsertComma(inputString: any) {
  // Replace "field" with "veld"
  const replacedString = inputString.replace(/field/gi, 'veld');
  
  // Insert a comma after "6v6"
  const finalString = replacedString.replace(/(\d+v\d+)/gi, '$1, ');

  return finalString;
},
		sendMailWithInvoiceOnPaid(event: any, paid: boolean) {
			console.log('sendMailWithInvoiceOnPaid', event);
			let player_email = event.email;
			let nameofPlayer = event.players;
			let location = event.pitch.location;
          const time_cal1 = dayjs(event.time_from, 'HH:mm');
          const time_cal2 = dayjs(event.time_to, 'HH:mm');
          // Determine if it's AM or PM based on your logic (e.g., if the hour is less than 12, it's AM)
          const amOrPm1 = time_cal1.hour() < 12 ? ' AM' : ' PM';
          const amOrPm2 = time_cal2.hour() < 12 ? ' AM' : ' PM';
			const display_date =
				location.city.country.id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9'
					? dayjs(event.date).format('DD.MM.YYYY') + ' ' + event.time_from + ' - ' + event.time_to + 'uur'
					: dayjs(event.date, 'DD.MM.YYYY').format('MMM D YYYY') + ' ' + event.time_from + amOrPm1+ ' - ' + event.time_to + amOrPm2;
			// const pitch = this.location.pitches.filter((ele: any)=> ele.id == event.split)
			let name = event.venue;
			let court = (this as any).replaceAndInsertComma(event.court);
			// let type = pitch[0].type.split('v')[0];
			let price = event.price;
			let bookedat = location.city.country.id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9' ? dayjs().format('DD.MM.YYYY HH:mm') + 'uur' : dayjs().format('MMM D YYYY h:mm A');
			let from = event.time_from;
			let to = event.time_to;
			let paymentMethodType = location.city.country.id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9' ? event.paymentMethod == 'On Location' ? 'Op locatie' : event.paymentMethod : event.paymentMethod ;
			let isPaid = location.city.country.id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9' ? event.isPublic ? 'Ja' : 'Nee' : event.isPublic ? 'Yes' : 'No';
			let percentDiscountAmount = Number(event.price) * (Number(event.discount) / 100);
			let discount = event.discountType == 'Percentage' ? percentDiscountAmount : Number(event.discount);
			// Invoice PDF
			const currentYear = dayjs().format('YYYY');
			const matchDate = dayjs(event.date).format('DD MMM YYYY');
			const playerBookingId = event.zendesk_id;
			// const senderLocation = this.location.address.split(',');
			const invoiceCurrency = location.currency;
			const invoiceBtw: any = location.city.country.id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9' ?location.vat ? location.vat : '9%' : '0%';
			const invoiceCity = location.city.name;
			const invoiceDate =  location.city.country.id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9' ? dayjs().format('DD MMM YYYY') : dayjs().format('MMM D YYYY');
			// const invoceUser = event.players;

			let btwArr = invoiceBtw.split('');
			btwArr.pop();
			let btwVal = btwArr.join('');
			const invoiceBtwPrice: any = location.city.country.id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9' ? (Number(price) - Number(price) / (1 + Number(btwVal) / 100)).toFixed(2) : Number(price) ;
			const bookingUrl =
				location.city.country_id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9'
					? 'https://footy.netlify.app/pick-location/nl'
					: 'https://footy.netlify.app/pick-location/us';

					
						try {
				console.log("try block")
				var formData = new FormData();
				formData.append('email', `info@footy.nl,harm@footy.nl,${player_email}`);
				formData.append('subject', 'Bevestiging boeking Footy');
				if (isPaid) {
					if(location.city.country_id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9'){
						formData.append(
						'pdf_body',
						`<!DOCTYPE html>
              <html>
              <head>
              <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap">
              </head>
              <body>
              <div>
                         <img 
                         style="width:100%;"
                           alt="logo" 
                         src="https://i.ibb.co/5BY3J8M/footy-header-2.png"  
                         >  
               </div>
               
                <div class="content-container" style="padding:10px 0;">
                  <div class="left-content" style="float: left;width: 50%;  padding: 0 20px;  box-sizing: border-box; ">
                    <p style="color:#366eb7">${nameofPlayer}</p>
                    
                  </div>
                  <div class="right-content" style="color:#366eb7;float: left; width: 50%;  padding: 0 85px; box-sizing: border-box;">
					${
						location.city.country_id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9'
							? `<p>Footy Amsterdam BV</p>
                    <p>Sportpark Spieringhorn 10</p>
                    <p>1043 AA Amsterdam</p>
                    <p>KVK 62063928</p>
                    <p>BTW NL 854625938 B01</p>
                    <p>NL97INGB0006935229</p>`
							: `<p>FOOTY PARK LLC</p>
              <p>1145 South Warren Avenue</p>
              <p>Tucson, AZ 85721</p>
              <p>AZ 85721</p>
              <p></p>
              <p></p>`
					}
                  </div>
                </div>
                
              <div class="table-container" style="clear: both;color:#366eb7; margin-top: 18px;padding-left:20px;">
                <p>Factuurnummer: LM${currentYear}-${playerBookingId}</p>
                <p>${invoiceDate}, ${invoiceCity}</p>
                <p>Geachte mevrouw, meneer,</p>
                <p>Wij brengen de volgende producten en diensten in rekening:</p>
              </div>
                <div style="text-align: center;margin-left:20px">
                  
                      <div style="">
                        <table border="1" style="color: #424242; border: 1px solid black; border-collapse: collapse; width: 100%">
                            <thead>
                               <tr style="color: #000000; font-weight: bold; height: 35px; border: 1px solid black;">
                                 <th style="border: 1px solid black;">Beschrijving</th>
                                 <th style="border: 1px solid black;">Locatie</th>
                                 <th style="border: 1px solid black;">Datum</th>
                                 <th style="border: 1px solid black;">Btw</th>
                                 <th style="border: 1px solid black;">Totaal</th>
                               </tr>
                             </thead>
                              <tbody>
                               <tr style="height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 35px">${court}</td>
                                 <td>${name}</td>
                                 <td style="border: 1px solid black;height: 35px">${matchDate} ${from} – ${to}</td>
                                 <td style="border: 1px solid black;height: 35px">${invoiceBtw}</td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${price}</td>
                               </tr>
                               <tr style="height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 25px">${discount !== 0 ? 'Korting' : ''} </td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="text-align: right; border: 1px solid;height: 35px black;">${discount !== 0 ? invoiceCurrency + discount : ''}</td>
                               </tr>
                              <tr style="height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 25px">Subtotal</td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="text-align: right; border: 1px solid;height: 35px black;">${invoiceCurrency} ${price}</td>
                               </tr>
                              <tr style="height: 35px; border: 1px solid black;height: 35px">
                                 <td style="border: 1px solid black;height: 35px">Netto prijs</td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${Number(price) -
							Number(invoiceBtwPrice)}</td>
                               </tr>
                               <tr style="height: 35px; border: 1px solid black;height: 35px">
                                 <td style="border: 1px solid black;height: 35px">Btw</td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px">${invoiceBtw}</td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${invoiceBtwPrice}</td>
                               </tr>
                               <tr style="color: #000000; font-weight: bold; height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 35px">Totaal</td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${price}</td>
                               </tr>
                             </tbody>
                        </table>
                      </div>
                 
                    
                  </div>
                                     
                      <p style="color:#366eb7; padding-left:20px;">Deze factuur is voor uw administratie. U heeft reeds betaald.</p>
                      <p style="margin-top:18px; color:#366eb7;padding-left:20px;"></p>
                      
                      <div style="margin-top: 20px;">
                        <div style="margin-top: 10px;float: left; width: 35%; text-align: center;">
                          <img 
                            src="https://i.ibb.co/ccJvG6j/logo-with-color.png" 
                            alt="logo" 
                          >
                        </div>
                       <div style="float: right; width: 65%" >
                           <img 
                              style="width: 60%;"
                               alt="logo" 
                               src="https://i.ibb.co/CWvRSF9/logo-play-footy.png"
                           >
                                       <p style="text-align: center; background-color: #029f8a; width:310px; padding: 5px; font-size: small; margin: 0 ; line-height: 1.5;">
                               BOEK EEN VELDJE VIA DE <a href=${bookingUrl} style="color: blue;">FOOTY APP!</a>
                             </p>
                           </div>
                      
                      <div style="margin-top: 64px;clear: both; color:#366eb7; float: right; width: 70%">
                        <p>
                          E: <a href="mailto:info@footy.nl" style="color: blue;">info@footy.nl</a> - 
                          M: +31 6 38032132 - 
                          W: <a href="https://www.footy.nl/" target="_blank" style="color: blue;">www.footy.nl</a>
                        </p>
                      </div>
           
                    
              </body>
              </html>`
					);
				}
				else {
					formData.append('pdf_body', `<!DOCTYPE html>
              <html>
              <head>
              <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap">
              </head>
              <body>
              <div>
                         <img 
                         style="width:100%;"
                           alt="logo" 
                         src="https://i.ibb.co/5BY3J8M/footy-header-2.png"  
                         >  
               </div>
               
                <div class="content-container" style="padding:10px 0;">
                  <div class="left-content" style="float: left;width: 50%;  padding: 0 20px;  box-sizing: border-box; ">
                    <p style="color:#366eb7">${nameofPlayer}</p>
                    
                  </div>
                  <div class="right-content" style="color:#366eb7;float: left; width: 50%;  padding: 0 85px; box-sizing: border-box;">
					${
						location.city.country_id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9'
							? `<p>Footy Amsterdam BV</p>
                    <p>Sportpark Spieringhorn 10</p>
                    <p>1043 AA Amsterdam</p>
                    <p>KVK 62063928</p>
                    <p>BTW NL 854625938 B01</p>
                    <p>NL97INGB0006935229</p>`
							: `<p>FOOTY PARK LLC</p>
              <p>1145 South Warren Avenue</p>
              <p>Tucson, AZ 85721</p>
              <p>AZ 85721</p>
              <p></p>
              <p></p>`
					}
                  </div>
                </div>
                
              <div class="table-container" style="clear: both;color:#366eb7; margin-top: 18px;padding-left:20px;">
                <p>Invoice: LM${currentYear}-${playerBookingId}</p>
                <p>${invoiceDate}, ${invoiceCity}</p>
                <p>Dear sir/madame,</p>
                <p>You have been charged for the following services:</p>
              </div>
                <div style="text-align: center;margin-left:20px">
                  
                      <div style="">
                        <table border="1" style="color: #424242; border: 1px solid black; border-collapse: collapse; width: 100%">
                            <thead>
                               <tr style="color: #000000; font-weight: bold; height: 35px; border: 1px solid black;">
                                 <th style="border: 1px solid black;">Description</th>
                                 <th style="border: 1px solid black;">Venue</th>
                                 <th style="border: 1px solid black;">Date</th>
                                 <th style="border: 1px solid black;">Btw (not for US)</th>
                                 <th style="border: 1px solid black;">Total</th>
                               </tr>
                             </thead>
                              <tbody>
                               <tr style="height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 35px">${court}</td>
                                 <td>${name}</td>
                                 <td style="border: 1px solid black;height: 35px">${display_date} </td>
                                 <td style="border: 1px solid black;height: 35px">${invoiceBtw}</td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${price}</td>
                               </tr>
                               <tr style="height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 25px">${discount !== 0 ? 'Discount' : ''} </td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="text-align: right; border: 1px solid;height: 35px black;">${discount !== 0 ? invoiceCurrency + discount : ''}</td>
                               </tr>
                              <tr style="height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 25px">Subtotal</td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="border: 1px solid black;height: 25px"></td>
                                 <td style="text-align: right; border: 1px solid;height: 35px black;">${invoiceCurrency} ${price}</td>
                               </tr>
                              <tr style="height: 35px; border: 1px solid black;height: 35px">
                                 <td style="border: 1px solid black;height: 35px">Net Price</td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${Number(price)}</td>
                               </tr>
                               <tr style="height: 35px; border: 1px solid black;height: 35px">
                                 <td style="border: 1px solid black;height: 35px">BTW</td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px">${invoiceBtw}</td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${invoiceBtwPrice}</td>
                               </tr>
                               <tr style="color: #000000; font-weight: bold; height: 35px; border: 1px solid black;">
                                 <td style="border: 1px solid black;height: 35px">Total</td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="border: 1px solid black;height: 35px"></td>
                                 <td style="text-align: right; border: 1px solid black;height: 35px">${invoiceCurrency} ${price}</td>
                               </tr>
                             </tbody>
                        </table>
                      </div>
                 
                    
                  </div>
                                     
                      <p style="color:#366eb7; padding-left:20px;">This invoice is for your administration. You have already paid.</p>
                      <p style="margin-top:18px; color:#366eb7;padding-left:20px;"></p>
                      
                      <div style="margin-top: 20px;">
                        <div style="margin-top: 10px;float: left; width: 35%; text-align: center;">
                          <img 
                            src="https://i.ibb.co/ccJvG6j/logo-with-color.png" 
                            alt="logo" 
                          >
                        </div>
                       <div style="float: right; width: 65%" >
                           <img 
                              style="width: 60%;"
                               alt="logo" 
                               src="https://i.ibb.co/CWvRSF9/logo-play-footy.png"
                           >
                                       <p style="text-align: center; background-color: #029f8a; width:310px; padding: 5px; font-size: small; margin: 0 ; line-height: 1.5;">
                               BOOK A FIELD TRHOUGH THE <a href=${bookingUrl} style="color: blue;">FOOTY APP!</a>
                             </p>
                           </div>
                      
                      <div style="margin-top: 64px;clear: both; color:#366eb7; float: right; width: 70%">
                        <p>
                          E: <a href="mailto:info@footy.nl" style="color: blue;">info@footy.nl</a> - 
                          M: +31 6 38032132 - 
                          W: <a href="https://www.footy.nl/" target="_blank" style="color: blue;">www.footy.nl</a>
                        </p>
                      </div>
           
                    
              </body>
              </html>`)
				}
					}
				
				if(location.city.country_id == 'e2c3e9c6-2477-4f71-a056-d37a9b3f60c9'){
				formData.append(
					'mail_body',
					`<div dir="ltr">
          <div class="gmail_quote"><br>
            <table id="m_-7222827482959669033m_-6943722573032268995background-table" style="table-layout: fixed; font-family: 'Open Sans', sans-serif;" border="0" cellpadding="0" cellspacing="0" align="center" width="100%">
              <tbody>
                <tr>
                  <td align="center" bgcolor="#E5E5E5"><br>
                    <table style="margin: 30px 10px; color: #000000; background-color: #ffffff;" border="0" cellpadding="0" cellspacing="0" width="640">
                      <tbody>
                        <tr>
                          <td align="center" width="640">
                            <table border="0" cellpadding="0" cellspacing="0" width="640"></table>
                          </td>
                        </tr>
                        <tr>
                          <td height="5" width="640"></td>
                        </tr>
                        <tr>
                          <td width="640">
                            <table border="0" cellpadding="0" cellspacing="0" align="left" width="640">
                              <tbody>
                                <tr>
                                  <td width="30"><br><br></td>
                                  <td width="580">
                                    <table border="0" cellpadding="0" cellspacing="0" width="580">
                                      <tbody>
                                        <tr style="font-size: 13px; line-height: 18px; color: #000000;">
                                          <td width="580" >
                                            <p style="font-size: 13px; line-height: 18px; color: #000000;">Hallo ${nameofPlayer},</p>
                                            <p style="font-size: 13px; line-height: 18px; color: #000000;">Bedankt voor je boeking bij Footy!</p>
                                            <p style="font-size: 13px; line-height: 18px; color: #000000;">Hieronder vind je de samenvatting van je boeking:</p>
                                            <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Contact &amp; route</p>
                                            <table style="font-size: 13px; line-height: 14px; color: #424242;">
                                              <tbody>
                                                <tr>
                                                  <td style="width: 130px;"><strong>Naam:</strong></td>
                                                  <td>${name}</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Adres:</strong></td>
                                                  <td>${location.address}</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Telefoon:</strong></td>
                                                  <td>+31 6 83133380</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>E-mail:</strong></td>
                                                  <td><a href="mailto:info@footy.nl" target="_blank" style="color: ##1a73e8;; text-decoration: none;">info@footy.nl</a></td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Links:</strong></td>
                                                  <td>
                                                    <a href="http://footy.nl" target="_blank" style="color: #1a73e8;; text-decoration: underline;">footy.nl</a>
                                                    <a href="https://maps.google.com?daddr=Sportpark%20Spieringhorn%2010%20+1043%20AA+Amsterdam" style="color: #1fa66f; text-decoration: underline;" target="_blank">Route</a>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Details</p>
                                            <table style="font-size: 13px; line-height: 14px; color: #424242;">
                                              <tbody>
                                                <tr>
                                                  <td style="width: 130px;"></td>
                                                  <td></td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Datum &amp; tijd:</strong></td>
                                                  <td>${display_date} uur</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Ruimte:</strong></td>
                                                  <td>${court}</td>
                                                </tr>
                                                <tr></tr>
                                                <tr>
                                                  <td><strong>Prijs:</strong></td>
                                                  <td>€ ${price}</td>
                                                </tr>
												<tr>
                                                  <td><strong>Betalingsmethode:</strong></td>
                                                  <td>${paymentMethodType}</td>
                                                </tr>
												<tr>
                                                  <td><strong>Betaald:</strong></td>
                                                  <td>${isPaid}</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Geboekt op:</strong><br></td>
                                                  <td>${bookedat} </td>
                                                </tr>
                                                <tr>
                                                  <td><br></td>
                                                  <td><br></td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Annuleringsvoorwaarden</p>
                                            <p align="left" style="line-height: 24px; color: #000000;">Annuleren en aanpassen is mogelijk via de <a href="https://footy.netlify.app/clubhouse" target="_blank" style="color: #1a73e8;; text-decoration: underline;">Footy App</a> tot 48 uur voor de boeking begint.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="20" width="580" style="font-size: 13px; line-height: 18px; color: #000000;">
                                            <p>Vriendelijke groeten,</p>
                                            <img src="https://i.ibb.co/vYysdsg/unnamed.png" alt="image.png" width="200" height="86" data-image-whitelisted="" class="CToWUd" data-bit="iit">
                                            <p><b style="color: rgb(34, 34, 34); font-family: Arial, Helvetica, sans-serif; font-size: small;">WORK HARD PLAY FOOTY</b></p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td width="30"></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td height="40" width="640" align="center"><p><br></p></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <img alt="logo" src="https://ci3.googleusercontent.com/mail-img-att/AEXG51nyRRvDUvYZPNYDg4KwunlosBTk2SeJ3XgWLMqvMBOUPf2e-ZskucveFobWEfruSWpnVZEVRwDa-ZW5PDkld-2MuSVJeRH8Si9-djdEAwMX1CPkTgS3qz8dfI-PZKM_VE6_RE2lu8-URvF-4sSQ9B4N6eUQOLfHjzcOEOkRniai4-Ke7uDxBENxxqY-nSoETTYhnPEJiVEMrd4sbJkm4m_AbWP7OA4s1TBa6PGhnQBD1h3c68LbYE5xARY4T6CfilodPI5szJy6coNpdk7gtFg-nWiEWLFw4ncSENC3tOPxzzVlvyi2Hzr2fM9IKV4IINofkRJoh_K350frr81IdRXRLJC7B6gqWZ0qQLQZG8kY1JX-gBR-9tZfUo5wJTQsvS62S5B2FBur87lRUn2phXZs0jJNNWSI9hKbZJfWw25oOHabATf3ocopSJP3qI8nsomxn1V-PVH3Qm-SiJZhLgoEFTYA3KuD1Wa7lU7w7EJugNJi66ich3529EZ5a0R5003357mYZuY1wi-2gb0690CUres9-Yjrlt8bC1aeSg1kenaO6qSQqozoJ7R-sUThTc2z-mJGzQ8LaPl-81pVU9bMsooHoWM1T8S3Qy5R1STzQcnJ8Rq4UcyXWdLp0Ux3ziwLPzXtLjpUScPdr9ufU8e98UDGpon-tiqCER1DeQ-YTiLC17I44iPixj_AZ-GukM_W0c97gr8Ebjg1caJ_PpX_pgx58Trch1XQWyNHOHvQF7384WMzmsYXB6lCato-x5llo51KBnu8BnxRvmVaihffA4z7PLKTRZQuFXxKW4fInIcUkFqABslytIci4Z6w70wJOtLnd85KbTNVeQiXkTlxRE2IsMiNxvB5BKk1vyXjwXXsg_OH1m035vVk3MTSnfFBIynN_BE95qkNLHRoyH6dQ9JdBimVv1ksdEkjHKRPxSboHMDjtSxZEzKXXw3YapH25SX8vF_WbdNVTZADNcTq3ERm2rqwxbpVa4FrIH1KO5krp1WKT1Yb17Bl7UiuRH4VHvqocpsSHmBzZsOh=s0-l75-ft" style="display: none; width: 1px; height: 1px;" class="CToWUd" data-bit="iit">
            <div class="yj6qo"></div>
            <div class="adL"></div>
          </div>
        </div>`
				);
			}
		else{
			formData.append(
					'mail_body',
					`<div dir="ltr">
          <div class="gmail_quote"><br>
            <table id="m_-7222827482959669033m_-6943722573032268995background-table" style="table-layout: fixed; font-family: 'Open Sans', sans-serif;" border="0" cellpadding="0" cellspacing="0" align="center" width="100%">
              <tbody>
                <tr>
                  <td align="center" bgcolor="#E5E5E5"><br>
                    <table style="margin: 30px 10px; color: #000000; background-color: #ffffff;" border="0" cellpadding="0" cellspacing="0" width="640">
                      <tbody>
                        <tr>
                          <td align="center" width="640">
                            <table border="0" cellpadding="0" cellspacing="0" width="640"></table>
                          </td>
                        </tr>
                        <tr>
                          <td height="5" width="640"></td>
                        </tr>
                        <tr>
                          <td width="640">
                            <table border="0" cellpadding="0" cellspacing="0" align="left" width="640">
                              <tbody>
                                <tr>
                                  <td width="30"><br><br></td>
                                  <td width="580">
                                    <table border="0" cellpadding="0" cellspacing="0" width="580">
                                      <tbody>
                                        <tr style="font-size: 13px; line-height: 18px; color: #000000;">
                                          <td width="580" >
                                            <p style="font-size: 13px; line-height: 18px; color: #000000;">Hallo ${nameofPlayer},</p>
                                            <p style="font-size: 13px; line-height: 18px; color: #000000;">Thank you for your booking at Footy! 

</p>
                                            <p style="font-size: 13px; line-height: 18px; color: #000000;">Below you find the summary of your booking:

</p>
                                            <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Contact &amp; route</p>
                                            <table style="font-size: 13px; line-height: 14px; color: #424242;">
                                              <tbody>
                                                <tr>
                                                  <td style="width: 130px;"><strong>Name:</strong></td>
                                                  <td>${name}</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Address:</strong></td>
                                                  <td>${location.address}</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Phone:</strong></td>
                                                  <td>+31 6 83133380</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Email:</strong></td>
                                                  <td><a href="mailto:info@footy.nl" target="_blank" style="color: ##1a73e8;; text-decoration: none;">info@footy.nl</a></td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Links:</strong></td>
                                                  <td>
                                                    <a href="http://footy.nl" target="_blank" style="color: #1a73e8;; text-decoration: underline;">footy.nl</a>
                                                    <a href="https://maps.google.com?daddr=Sportpark%20Spieringhorn%2010%20+1043%20AA+Amsterdam" style="color: #1fa66f; text-decoration: underline;" target="_blank">Route</a>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Details</p>
                                            <table style="font-size: 13px; line-height: 14px; color: #424242;">
                                              <tbody>
                                                <tr>
                                                  <td style="width: 130px;"></td>
                                                  <td></td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Date &amp; Time:</strong></td>
                                                  <td>${display_date} </td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Field:</strong></td>
                                                  <td>${court}</td>
                                                </tr>
                                                <tr></tr>
                                                <tr>
                                                  <td><strong>Price:</strong></td>
                                                  <td>€ ${price}</td>
                                                </tr>
												<tr>
                                                  <td><strong>Payment method:</strong></td>
                                                  <td>${paymentMethodType}</td>
                                                </tr>
												<tr>
                                                  <td><strong>Paid:</strong></td>
                                                  <td>${isPaid}</td>
                                                </tr>
                                                <tr>
                                                  <td><strong>Booked on:</strong><br></td>
                                                  <td>${bookedat} </td>
                                                </tr>
                                                <tr>
                                                  <td><br></td>
                                                  <td><br></td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Cancelation conditions</p>
                                            <p align="left" style="line-height: 24px; color: #000000;">Canceling and editing is possible through the <a href="https://footy.netlify.app/clubhouse" target="_blank" style="color: #1a73e8;; text-decoration: underline;">Footy App</a> up to 48 hours before the booking.</p>
                                            
                                            <p style="color: #000000;">See you shortly! </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="20" width="580" style="font-size: 13px; line-height: 18px; color: #000000;"><br/>
                                            <p>Best regards,</p>
                                            <img src="https://i.ibb.co/vYysdsg/unnamed.png" alt="image.png" width="200" height="86" data-image-whitelisted="" class="CToWUd" data-bit="iit">
                                            <p><b style="color: rgb(34, 34, 34); font-family: Arial, Helvetica, sans-serif; font-size: small;">WORK HARD PLAY FOOTY</b></p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td width="30"></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td height="40" width="640" align="center"><p><br></p></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <img alt="logo" src="https://ci3.googleusercontent.com/mail-img-att/AEXG51nyRRvDUvYZPNYDg4KwunlosBTk2SeJ3XgWLMqvMBOUPf2e-ZskucveFobWEfruSWpnVZEVRwDa-ZW5PDkld-2MuSVJeRH8Si9-djdEAwMX1CPkTgS3qz8dfI-PZKM_VE6_RE2lu8-URvF-4sSQ9B4N6eUQOLfHjzcOEOkRniai4-Ke7uDxBENxxqY-nSoETTYhnPEJiVEMrd4sbJkm4m_AbWP7OA4s1TBa6PGhnQBD1h3c68LbYE5xARY4T6CfilodPI5szJy6coNpdk7gtFg-nWiEWLFw4ncSENC3tOPxzzVlvyi2Hzr2fM9IKV4IINofkRJoh_K350frr81IdRXRLJC7B6gqWZ0qQLQZG8kY1JX-gBR-9tZfUo5wJTQsvS62S5B2FBur87lRUn2phXZs0jJNNWSI9hKbZJfWw25oOHabATf3ocopSJP3qI8nsomxn1V-PVH3Qm-SiJZhLgoEFTYA3KuD1Wa7lU7w7EJugNJi66ich3529EZ5a0R5003357mYZuY1wi-2gb0690CUres9-Yjrlt8bC1aeSg1kenaO6qSQqozoJ7R-sUThTc2z-mJGzQ8LaPl-81pVU9bMsooHoWM1T8S3Qy5R1STzQcnJ8Rq4UcyXWdLp0Ux3ziwLPzXtLjpUScPdr9ufU8e98UDGpon-tiqCER1DeQ-YTiLC17I44iPixj_AZ-GukM_W0c97gr8Ebjg1caJ_PpX_pgx58Trch1XQWyNHOHvQF7384WMzmsYXB6lCato-x5llo51KBnu8BnxRvmVaihffA4z7PLKTRZQuFXxKW4fInIcUkFqABslytIci4Z6w70wJOtLnd85KbTNVeQiXkTlxRE2IsMiNxvB5BKk1vyXjwXXsg_OH1m035vVk3MTSnfFBIynN_BE95qkNLHRoyH6dQ9JdBimVv1ksdEkjHKRPxSboHMDjtSxZEzKXXw3YapH25SX8vF_WbdNVTZADNcTq3ERm2rqwxbpVa4FrIH1KO5krp1WKT1Yb17Bl7UiuRH4VHvqocpsSHmBzZsOh=s0-l75-ft" style="display: none; width: 1px; height: 1px;" class="CToWUd" data-bit="iit">
            <div class="yj6qo"></div>
            <div class="adL"></div>
          </div>
        </div>
				
`
				);
		}
				formData.append('token', '-5&abBCiIw%aHML7Jev41TdOwdDRY8tlM8yX!!AEox5fy-D&');
				formData.append('from_name', 'Footy');
				formData.append('from_email', 'info@footy.nl');

				const response = axios.post('https://www.footy.nl/wp-json/wp/v1/send-email/', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				});
				console.log('response', response);
				this.$store.commit('setLoadingState', false);
			} catch (error) {
				console.log('Mail_Not_Send', error);
			}
			
			
		},
		async markAsPaid(item: any, paid: boolean) {
			console.log('item', item, paid);
			if (item.type == 'customer_booking') {
				await apolloClient.mutate({
					mutation: gql`
						mutation updateCustomerBookingPaid($paid: Boolean!, $customer_id: uuid!, $id: uuid!, $is_public: Boolean!) {
							update_customer_bookings(_set: { paid: $paid, is_public: $is_public }, where: { customer_id: { _eq: $customer_id }, id: { _eq: $id } }) {
								affected_rows
							}
						}
					`,
					variables: {
						id: item.id,
						customer_id: item.customer_id,
						is_public: paid,
						paid: paid,
					},
				});
			} else if (item.type == 'player_booking') {
				await apolloClient.mutate({
					mutation: gql`
						mutation updateCustomerBookingPaid($paid: Boolean!, $id: Int!) {
							update_player_booking_schedules(_set: { paid: $paid }, where: { id: { _eq: $id } }) {
								affected_rows
							}
						}
					`,
					variables: {
						id: item.id,
						paid: paid,
					},
				});
			}
			if (paid) {
				// send mail
				(this as any).sendMailWithInvoiceOnPaid(item,paid);
			}
			await this.$store.dispatch('getLMBookings');
			console.log('markAsPaid', item, paid);
		},
		getcityName(item: any) {
			let val;
			val = (this as any).CitiesOptionsForReport.filter((c: any) => c.city_id === item);
			console.log('(this as any).CitiesOptionsForReport', val[0].city_name);
			return val[0].city_name;
		},
		showDialog(item : any ,event : any) {
			event.stopPropagation();
			this.cancelDialog = true;
			this.tempBookingDetails = item;
		},
		async sendmailAndCancelBooking() {
			// console.log('this.tempBookingDetails', this.tempBookingDetails);
			try {
				let type = (this as any).tempBookingDetails.pitch_type.split('v')[0];
				const response = await axios.post('https://www.footy.nl/wp-json/wp/v1/send-email/', {
					email: `info@footy.nl,harm@footy.nl, ${(this as any).tempBookingDetails.email}`,
					subject: 'Annulering boeking Footy',
					mail_body: `<div dir="ltr">
  <div class="gmail_quote"><br>
    <table id="m_-7222827482959669033m_-6943722573032268995background-table" style="table-layout: fixed; font-family: 'Open Sans', sans-serif;" border="0" cellpadding="0" cellspacing="0" align="center" width="100%">
      <tbody>
        <tr>
          <td align="center" bgcolor="#E5E5E5"><br>
            <table style="margin: 30px 10px; color: #000000; background-color: #ffffff;" border="0" cellpadding="0" cellspacing="0" width="640">
              <tbody>
                <tr>
                  <td align="center" width="640">
                    <table border="0" cellpadding="0" cellspacing="0" width="640"></table>
                  </td>
                </tr>
                <tr>
                  <td height="5" width="640"></td>
                </tr>
                <tr>
                  <td width="640">
                    <table border="0" cellpadding="0" cellspacing="0" align="left" width="640">
                      <tbody>
                        <tr>
                          <td width="30"><br><br></td>
                          <td width="580">
                            <table border="0" cellpadding="0" cellspacing="0" width="580">
                              <tbody>
                                <tr style="font-size: 13px; line-height: 18px; color: #000000;">
                                  <td width="580" >
                                    <p style="font-size: 13px; line-height: 18px; color: #000000;">Hallo ${(this as any).tempBookingDetails.players},</p>
                                    <p style="font-size: 13px; line-height: 18px; color: #000000;">Jammer dat je de boeking hebt geannuleerd.</p>
                                    <p style="font-size: 13px; line-height: 18px; color: #000000;">Het betreft onderstaande boeking:</p>
                                    <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Contact &amp; route</p>
                                    <table style="font-size: 13px; line-height: 14px; color: #424242;">
                                      <tbody>
                                        <tr>
                                          <td style="width: 130px;"><strong>Naam:</strong></td>
                                          <td>${(this as any).tempBookingDetails.players}</td>
                                        </tr>
                                        <tr>
                                          <td><strong>Adres:</strong></td>
                                          <td>${(this as any).tempBookingDetails.venue}</td>
                                        </tr>
                                        <tr>
                                          <td><strong>Telefoon:</strong></td>
                                          <td>+31 6 83133380</td>
                                        </tr>
                                        <tr>
                                          <td><strong>E-mail:</strong></td>
                                          <td><a href="mailto:info@footy.nl" target="_blank" style="color: ##1a73e8;; text-decoration: none;">info@footy.nl</a></td>
                                        </tr>
                                        <tr>
                                          <td><strong>Links:</strong></td>
                                          <td>
                                            <a href="http://footy.nl" target="_blank" style="color: #1a73e8;; text-decoration: underline;">footy.nl</a>
                                            <a href="https://maps.google.com?daddr=Sportpark%20Spieringhorn%2010%20+1043%20AA+Amsterdam" style="color: #1fa66f; text-decoration: underline;" target="_blank">Route</a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Details</p>
                                    <table style="font-size: 13px; line-height: 14px; color: #424242;">
                                      <tbody>
                                        <tr>
                                          <td style="width: 130px;"></td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td><strong>Datum &amp; tijd:</strong></td>
                                          <td>${(this as any).tempBookingDetails.date +
																						' ' +
																						(this as any).tempBookingDetails.time_from +
																						' - ' +
																						(this as any).tempBookingDetails.time_to}  uur</td>
                                        </tr>
                                        <tr>
                                          <td><strong>Ruimte:</strong></td>
                                          <td>${type} vs. ${type}, Veld ${(this as any).tempBookingDetails.court}</td>
                                        </tr>
                                        <tr></tr>
                                        <tr>
                                          <td><strong>Prijs:</strong></td>
                                          <td>€ ${(this as any).tempBookingDetails.price}</td>
                                        </tr>
										<tr>
											<td><strong>Betalingsmethode:</strong></td>
											<td>${(this as any).tempBookingDetails.payment}</td>
										</tr>
										<tr>
											<td><strong>Betaald:</strong></td>
											<td>${(this as any).tempBookingDetails.paid}</td>
										</tr>
                                        <tr>
                                          <td><strong>Geannuleerd op:</strong><br></td>
                                          <td>${(this as any).tempBookingDetails.bookedOn} uur</td>
                                        </tr>
                                        <tr>
                                          <td><br></td>
                                          <td><br></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <p align="left" style="font-size: 18px; line-height: 24px; color: #000000; font-weight: bold;">Terugbetaling</p>
									<p align="left" style="line-height: 24px; color: #000000;">Jouw betaling wordt binnen 24 uur terug gestord naar jouw rekening.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td height="20" width="580" style="font-size: 13px; line-height: 18px; color: #000000;">
                                    <p>Met vriendelijke groet,</p>
                                    <img src="https://i.ibb.co/vYysdsg/unnamed.png" alt="image.png" width="200" height="86" data-image-whitelisted="" class="CToWUd" data-bit="iit">
                                    <p><b style="color: rgb(34, 34, 34); font-family: Arial, Helvetica, sans-serif; font-size: small;">WORK HARD PLAY FOOTY</b></p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td width="30"></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td height="40" width="640" align="center"><p><br></p></td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <img alt="logo" src="https://ci3.googleusercontent.com/mail-img-att/AEXG51nyRRvDUvYZPNYDg4KwunlosBTk2SeJ3XgWLMqvMBOUPf2e-ZskucveFobWEfruSWpnVZEVRwDa-ZW5PDkld-2MuSVJeRH8Si9-djdEAwMX1CPkTgS3qz8dfI-PZKM_VE6_RE2lu8-URvF-4sSQ9B4N6eUQOLfHjzcOEOkRniai4-Ke7uDxBENxxqY-nSoETTYhnPEJiVEMrd4sbJkm4m_AbWP7OA4s1TBa6PGhnQBD1h3c68LbYE5xARY4T6CfilodPI5szJy6coNpdk7gtFg-nWiEWLFw4ncSENC3tOPxzzVlvyi2Hzr2fM9IKV4IINofkRJoh_K350frr81IdRXRLJC7B6gqWZ0qQLQZG8kY1JX-gBR-9tZfUo5wJTQsvS62S5B2FBur87lRUn2phXZs0jJNNWSI9hKbZJfWw25oOHabATf3ocopSJP3qI8nsomxn1V-PVH3Qm-SiJZhLgoEFTYA3KuD1Wa7lU7w7EJugNJi66ich3529EZ5a0R5003357mYZuY1wi-2gb0690CUres9-Yjrlt8bC1aeSg1kenaO6qSQqozoJ7R-sUThTc2z-mJGzQ8LaPl-81pVU9bMsooHoWM1T8S3Qy5R1STzQcnJ8Rq4UcyXWdLp0Ux3ziwLPzXtLjpUScPdr9ufU8e98UDGpon-tiqCER1DeQ-YTiLC17I44iPixj_AZ-GukM_W0c97gr8Ebjg1caJ_PpX_pgx58Trch1XQWyNHOHvQF7384WMzmsYXB6lCato-x5llo51KBnu8BnxRvmVaihffA4z7PLKTRZQuFXxKW4fInIcUkFqABslytIci4Z6w70wJOtLnd85KbTNVeQiXkTlxRE2IsMiNxvB5BKk1vyXjwXXsg_OH1m035vVk3MTSnfFBIynN_BE95qkNLHRoyH6dQ9JdBimVv1ksdEkjHKRPxSboHMDjtSxZEzKXXw3YapH25SX8vF_WbdNVTZADNcTq3ERm2rqwxbpVa4FrIH1KO5krp1WKT1Yb17Bl7UiuRH4VHvqocpsSHmBzZsOh=s0-l75-ft" style="display: none; width: 1px; height: 1px;" class="CToWUd" data-bit="iit">
    <div class="yj6qo"></div>
    <div class="adL"></div>
  </div>
</div>`,
					token: '-5&abBCiIw%aHML7Jev41TdOwdDRY8tlM8yX!!AEox5fy-D&',
					from_name: 'Footy',
					from_email: 'info@footy.nl',
				});
				(this as any).cancelBooking(this.tempBookingDetails);
				// Handle the response data
				console.log('response', response.data);
				this.cancelDialog = false;
			} catch (error) {
				// Handle any errors
				console.log('errorrrrrrrrrrrrrrrrrr', error);
				console.error(error);
			}
		},
		async generatePDF() {
			this.pdf = true;
			const content = this.$refs.pdfContent;
			const options = {
				margin: [0, 0],
				filename: 'Report.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { dpi: 192, letterRendering: true },
				jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
			};
			await html2pdf()
				.from(content)
				.set(options)
				.save();
			this.pdf = false;
		},
		calculatePrice(item: any) {
			let sum = 0;
			item.forEach((obj: any) => {
				if (obj.payment !== null) sum = sum + obj.price;
			});
			return sum.toFixed(2);
		},
		
		async cancelBooking(item: any) {
			this.selectedItem = item;
			console.log('cancelBooking', item);
			let currentDate = dayjs().format('YYYY/MM/DD HH:mm');
			if (item.type === 'player_booking') {
				if (item.payment_id && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev')) {
					try {
						const res = await apiService.post('lm/refunddev', item.payment_id);
						console.log('response of API', res);
					} catch (err) {
						console.log('err', err);
					}
				} else {
					try {
						const res = await apiService.post('lm/refund', item.payment_id);
						console.log('response of API', res);
					} catch (err) {
						console.log('err', err);
					}
				}
				let id = '';
				let deleteoptions = {
					date: item.date,
					location_id: item.location_id,
					player_booking_id: item.id,
					display_date: item.display_date,
					price: item.price.toString(),
					pitchId: item.pitchId,
					pitch_id: item.pitch_id,
					pitch_type: item.pitch_type,
					split: item.split,
					time_from: item.time_from,
					time_to: item.time_to,
					bookedOn: item.bookedOn,
					players: item.players,
					booker: item.booker,
					venu: item.venue,
					payment: item.payment,
					city_id: item.city_id,
					country: item.country,
					email: item.email,
					edited_on: currentDate,
				};
				console.log('cancel Player booking', deleteoptions);
				await this.$store.dispatch('setPlayerBookingCancelled', deleteoptions);
				id = await this.$store.dispatch('deleteplayerBooking', item.id);
				await this.$store.dispatch('getLMBookings');
				this.snackbar = true;
			} else {
				let deleteoptions = {
					date: item.date,
					display_date: item.date + ' ' + item.time_from + '-' + item.time_to,
					pitch_id: item.split,
					location_id: item.location_id,
					customer_booking_id: item.customer_id,
					price: item.price.toString(),
					pitch_type: item.pitch_type,
					split: item.split,
					time_from: item.time_from,
					time_to: item.time_to,
					deleted_id: item.id,
					bookedOn: item.bookedOn,
					players: item.players,
					booker: item.booker,
					venu: item.venue,
					payment: item.payment,
					city_id: item.city_id,
					country: item.country,
					is_public: item.paid,
					email: item.email,
					edited_on: currentDate,
				};
				console.log('cancel customer booking', deleteoptions);
				await this.$store.dispatch('setCustomerBookingCancled', deleteoptions);
				let ids = await this.$store.dispatch('deleteCustomerBooking', item.id);
				await this.$store.dispatch('getLMBookings');
				this.snackbar = true;
			}
			await this.$store.dispatch('getLMBookings');
			await this.$store.dispatch('getLMReports', this.reportFilters);
			await this.$store.dispatch('getPlayerBookingCancled', this.reportFilters);
			await this.$store.dispatch('getCustomerBookingCancled', this.reportFilters);
		},
		async loadItems() {
			await this.$store.dispatch('getLMBookings', this.bookingFilters);
			await this.$store.dispatch('getLMReports', this.reportFilters);
			this.items = (this as any).bookings;
			const uniqueItems: any[] = [];
			const duplicates: any[] = [];
			this.items.forEach(async (item: any) => {
				if (
					item.type == 'player_booking' &&
					uniqueItems.some(
						uItem =>
							uItem.price == item.price &&
							uItem.date === item.date &&
							uItem.time_to === item.time_to &&
							uItem.time_from === item.time_from &&
							uItem.split === item.split &&
							uItem.pitch_type === item.pitch_type &&
							uItem.location_id === item.location_id
					)
				) {
					await this.$store.dispatch('deleteplayerBooking', item.id);
					duplicates.push(item);
				} else {
					uniqueItems.push(item);
				}
			});
			await this.$store.dispatch('getLMBookings');
			console.log('duplicates', duplicates, 'uniqueItems', uniqueItems);
			this.items1 = (this as any).reports;
			this.items2 = (this as any).playerBookingCancled;
			this.items3 = (this as any).customerBookingCancled;
			this.items1.forEach((obj: any, idx) => {
				this.currency = obj.currency;
			});
		},
		clearFilters() {
			(this as any).bookingFilters = {
				country: '',
				cities: [],
				players: '',
				venue: [],
			};
		},
		clearFiltersReport() {
			(this as any).reportFilters = {
				country: '',
				cities: [],
				players: '',
				venue: [],
				date_from: '',
				date_to: '',
			};
		},
	},
});
